import { ExtendedTheme } from '@sightworks/theme';

export default (theme: ExtendedTheme) => ({
	root: {
		fontWeight: 'bold',
	},
});
